import React, { useState } from "react";
import {
  Menu,
  X,
  Leaf,
  Award,
  Cpu,
  Heart,
  Star,
  ArrowLeft,
  Cookie,
  CheckCircle2,
  Facebook,
  Instagram,
  Phone,
  Mail,
  MapPin,
  ChevronLeft,
} from "lucide-react";
import "./AboutUs2.css";
import { useNavigate } from "react-router-dom";

// --- الثوابت والبيانات ---

const COMPANY_INFO = {
  founded: "2023",
  name: "بيسكوزا",
  tagline: "لحظات من السعادة",
  story_title: "حكاية تأسيس بيسكوزا",
  story_text_1:
    "شركة سورية متخصصة في صناعة البسكويت تأسست عام 2023 بشغف كبير لتقديم منتجات عالية الجودة تجمع بين المكونات المتميزة والأصناف اللذيذة لتوفر تجربة طعم استثنائية لكل من يتذوقها.",
  story_text_2:
    "نحن في شركة بيسكوزا منذ أن بدأنا نحرص على استخدام أجود المكونات لإنتاج أصناف ذات جودة عالية من البسكويت المحشي والمغطس بالشوكولا والمارشميلو اللذيذ مع إدخال وصفاتنا الشهيّة والمتميزة لتضفي لحظات من السعادة على حياتكم اليومية.",
  quality_text:
    "التزامنا بالجودة والتميز والمعايير العالمية لتحقيق رضا زبائننا هو ما يدفعنا للحفاظ على أعلى المعايير في كل منتج نقدمه من حيث جودة المكونات، النظافة والتعقيم، المختبرات وخطوط الإنتاج مُدارة بالكامل من قبل أجهزة الكومبيوتر والتحكم الآلي دون تدخل العامل البشري خلال مراحل الإنتاج، حتى اختيار الأغلفة ومواد التغليف الراقية والتي تليق بمنتجات بيسكوزا لنضيف بصمة متميزة في عالم البسكويت والشوكولا.",
  mission:
    "في بيسكوزا نؤمن أن قطعة من البسكويت قد تكون سبباً لسعادة تشعر بها خلال يومك",
};

const NAV_LINKS = [
  { label: "الرئيسية", href: "#" },
  { label: "من نحن", href: "#" },
  { label: "منتجاتنا", href: "#" },
  { label: "تواصل معنا", href: "#" },
];

const FEATURES = [
  {
    title: "أجود المكونات",
    description:
      "ننتقي القمح الفاخر، الكاكاو الغني، والمكونات الطبيعية لنضمن طعماً لا ينسى.",
    icon: <Leaf />,
  },
  {
    title: "تكنولوجيا متطورة",
    description:
      "خطوط إنتاج مؤتمتة بالكامل لضمان أعلى معايير النظافة والدقة في كل قطعة.",
    icon: <Cpu />,
  },
  {
    title: "جودة عالمية",
    description:
      "نلتزم بمعايير الجودة العالمية في التصنيع والتغليف لتقديم منتج يليق بكم.",
    icon: <Award />,
  },
  {
    title: "شغفنا السعادة",
    description:
      "كل وصفة نبتكرها هدفها الأساسي هو رسم الابتسامة وإضافة لحظة فرح.",
    icon: <Heart />,
  },
];

const Hero = () => {
  const navigate = useNavigate();
  return (
    <section className="hero-section">
      <div className="aboutus-container hero-content">
        <div className="hero-grid">
          <div className="hero-text">
            <div className="badge">
              <Star size={16} className="text-gold" fill="currentColor" />
              <span>قصة نجاح سورية منذ {COMPANY_INFO.founded}</span>
            </div>

            <h1 className="hero-title">
              طعم يأخذك إلى <br />
              <span className="hero-title-highlight">
                عالم السعادة
                <svg
                  className="underline-svg"
                  viewBox="0 0 100 10"
                  preserveAspectRatio="none"
                ></svg>
              </span>
            </h1>

            <p className="hero-description">
              في بيسكوزا، نمزج الشغف بأجود المكونات الطبيعية لنقدم لكم بسكويت
              يحمل في كل قطعة منه لحظة فرح حقيقية.
            </p>

            <div className="hero-buttons">
              <button
                className="btn-primary btn-lg"
                onClick={() => navigate("/Products")}
              >
                <Cookie size={20} />
                <span className="taste">تذوق منتجاتنا</span>
              </button>
            </div>

            <div className="hero-stats">
              <div className="stat-item">
                <p className="stat-value">15 +</p>
                <p className="stat-label">صنف مميز</p>
              </div>
              <div className="stat-divider"></div>
              <div className="stat-item">
                <p className="stat-value">100 %</p>
                <p className="stat-label">جودة عالمية</p>
              </div>
            </div>
          </div>

          <div className="hero-image-wrapper">
            <div className="hero-blob-bg">
              <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill="#dd2727"
                  fillOpacity="0.08"
                  d="M44.7,-76.4C58.9,-69.2,71.8,-59.1,81.6,-46.6C91.4,-34.1,98.1,-19.2,95.8,-4.9C93.5,9.3,82.2,22.9,71.6,34.6C61,46.3,51.1,56.1,39.9,64.3C28.7,72.5,16.2,79.1,2.6,74.6C-11,70.1,-25.7,54.5,-38.9,41.3C-52.1,28.1,-63.8,17.3,-68.6,3.6C-73.4,-10.1,-71.3,-26.7,-62.7,-40.4C-54.1,-54.1,-39,-64.9,-24.3,-71.7C-9.6,-78.5,4.7,-81.3,19.8,-80.8L44.7,-76.4Z"
                  transform="translate(100 100)"
                />
              </svg>
            </div>

            <div className="hero-img-container">
              <img
                src="/images/Huggy.webp"
                alt="Delicious Biscoza Biscuits"
                className="hero-main-img"
              />

              <div className="floating-card card-bottom">
                <div className="card-header">
                  <div className="icon-circle">
                    <CheckCircle2 size={15} color="red" />
                  </div>
                  <span className="card-text">طعم لا يقاوم</span>
                </div>
                <div className="progress-bar"></div>
              </div>

              <div className="floating-card card-top">
                <span className="emoji">😋</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const StorySection = () => {
  return (
    <section className="story-section">
      <div className="aboutus-container">
        <div className="story-grid">
          <div className="story-content">
            <div className="title-wrapper">
              <h2 className="section-title">{COMPANY_INFO.story_title}</h2>
              <div className="title-decoration"></div>
            </div>

            <div className="story-text">
              <p className="story-intro">{COMPANY_INFO.story_text_1}</p>
              <p>{COMPANY_INFO.story_text_2}</p>
            </div>
          </div>

          <div className="story-image-group">
            <div className="img-bg-red"></div>
            <div className="img-bg-gold"></div>

            <div className="story-img-container">
              <img
                src="/images/dishleft.webp"
                alt="Biscuit Manufacturing"
                className="story-img"
              />
              <div className="story-badge">
                <span>منذ 2023</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const QuoteSection = () => {
  return (
    <section className="quote-section">
      <div className="quote-bg-shapes"></div>

      <div className="aboutus-container quote-container">
        <h2 className="quote-text">
          " نؤمن أن قطعة من البسكويت قد تكون سبباً لسعادة تشعر بها خلال يومك "
        </h2>
        <div className="quote-line"></div>
      </div>
    </section>
  );
};

const QualitySection = () => {
  return (
    <section className="quality-section">
      <div className="wave-separator">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"></path>
        </svg>
      </div>

      <div className="aboutus-container quality-container-inner">
        <div className="section-header center-text">
          <h2 className="section-title text-dark">
            التزامنا <span className="text-red">بالجودة والتميز</span>
          </h2>
          <p className="section-desc">{COMPANY_INFO.quality_text}</p>
        </div>

        <div className="features-grid">
          {FEATURES.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon-wrapper">
                {React.cloneElement(feature.icon, {
                  className: "feature-icon",
                })}
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-desc">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default function AboutUs() {
  return (
    <div className="app-root">
      <main>
        <Hero />
        <StorySection />
        <QuoteSection />
        <QualitySection />
      </main>
    </div>
  );
}
